// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ju-0";
export var fulfillmentPanelBody = "_ju-1";